import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs } from "@/components/ui/tabs";
import TabsHeader from "@/components/super-admin/tabs/TabsHeader";
import TabsNavigation from "@/components/super-admin/tabs/TabsNavigation";
import TabsContentWrapper from "@/components/super-admin/tabs/TabsContent";

const MainTabs = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <Card className="bg-white shadow-lg w-full min-w-0 overflow-hidden">
      <TabsHeader />
      <CardContent className="min-w-0 px-3">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full min-w-0" dir="rtl">
          <TabsNavigation />
          <TabsContentWrapper />
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default MainTabs;
